import React from 'react';
import Icon from './Icon';
import {Path} from 'react-native-svg';

const WifiIcon = (props: any) => {
  return (
    <Icon {...props}>
      <Path
        fill="#000"
        d="m12 21 3.6-4.8c-1-.75-2.25-1.2-3.6-1.2s-2.6.45-3.6 1.2L12 21ZM12 9c-2.7 0-5.19.89-7.2 2.4l1.8 2.4C8.1 12.67 9.97 12 12 12c2.03 0 3.9.67 5.4 1.8l1.8-2.4C17.19 9.89 14.7 9 12 9ZM12 3C7.95 3 4.21 4.34 1.2 6.6L3 9c2.5-1.88 5.62-3 9-3s6.5 1.12 9 3l1.8-2.4C19.79 4.34 16.05 3 12 3Z"
      />
    </Icon>
  );
};

export default React.memo(WifiIcon);
